<template>
  <div class="main">
    <!-- 顶部蓝色渐变区域 -->
    <div class="header-section">
    </div>

    <!-- 白色卡片层 -->
    <div class="card-section">
      <!-- Logo区域 -->
      <div class="logo-area">
        <img src="../assets/img/logo-deo.png" alt="logo" class="debaoImg">
      </div>

      <!-- 系统标题 -->
      <div class="system-title">
        <h1>智能客服系统</h1>
        <p>Intelligent customer service system</p>
      </div>

      <!-- 登录表单 -->
      <div class="login-form">
        <div class="input-wrapper">
          <van-field
            readonly
            clickable
            name="picker"
            :value="testName"
            placeholder="用户名"
            @click="showPicker = true"
            class="username-field"
          />
        </div>
        <van-button
          round
          block
          class="login-btn"
          @click="testLoginFn"
        >
          登录
        </van-button>
      </div>
    </div>

    <van-popup
      v-model="showPicker"
      position="bottom"
      :style="{ width: '100vw', left: '0', borderRadius: '15px 15px 0 0' }"
    >
      <van-picker
        show-toolbar
        value-key="name"
        :columns="testData"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import {authorize, getConfigInfo} from '../service/getData'
import {setToken, setLoginInfo, setCheckLoginInfo, setAccountInfo, setConfig} from '../util/auth'
import {Toast} from 'vant'
import {userInfo} from '../assets/js/userInfo'

export default {
  data () {
    return {
      accountName: 'ics-zlt', // 企业账号信息
      loading: false,
      loginData: {
        nickname: '',
        companyAccount: '',
        companySecretKey: '',
        uniqueCode: '',
        password: ''
      },
      userInfo, // 本地存储的用户账户信息，用于模拟登录
      testData: [
        {name: '章山', code: '3500B914251F26831BE87759B122A48B'},
        {name: '李思', code: 'E80C5C920E5F516FBCF858147E35DAFC'},
        {name: '王武', code: '91A7D29084650CBA6BB219DA7E0FA728'},
        {name: '赵柳', code: '1185DFEE86E7B36D4A552E374872831B'},
        {name: '田启', code: '11E12283DCF690A780EABCE4A6973629'},
        {name: '吴霸', code: '8687090A83B63E98F1064DF4BB4CD16C'},
        {name: '孙咎', code: 'EE8DFB9AF5B02276E02688C8DCC85077'},
        {name: '周石', code: '3967A7954ACAEE2B299458B9DA2D608B'},
        {name: '冯诗亿', code: '73228559C7B6D059B3C22C9C88CEFC4B'},
        {name: '陈师儿', code: '9CC2C4BA027D721247E9A30CCA2C95B3'}
      ],
      showPicker: false,
      testName: '',
      code: ''
    }
  },
  methods: {
    // 原版登录
    // login () {
    //   const {companyAccount, companySecretKey, uniqueCode, password} = this.loginData
    //
    //   const user = this.userInfo.find(
    //     item => item.companyAccount === companyAccount &&
    //       item.companySecretKey === companySecretKey &&
    //       item.uniqueCode === uniqueCode &&
    //       item.password === password
    //   )
    //
    //   if (user) {
    //     // 本地校验成功，进行后端校验
    //     let params = {
    //       companyAccount: user.companyAccount,
    //       companySecretKey: user.companySecretKey,
    //       belongCompanyCode: user.belongCompanyCode,
    //       nickname: user.nickname,
    //       uniqueCode: user.uniqueCode,
    //       belongCompanyName: user.belongCompanyName
    //     }
    //
    //     loginSystem(params).then(res => {
    //       if (res.code === 0) {
    //         this.$router.push({name: 'chatDetail'})
    //         setToken(res.data.token)
    //         setLoginInfo(res.data)
    //         // 存储本地json信息
    //         let account = this.loginData
    //         account.belongCompanyCode = user.belongCompanyCode
    //         account.belongCompanyName = user.belongCompanyName
    //         localStorage.setItem('account', JSON.stringify(account))
    //       } else {
    //         Toast.fail(res.msg)
    //       }
    //     })
    //   } else {
    //     const companyExists = this.userInfo.some(item => item.companyAccount === companyAccount)
    //     if (!companyExists) {
    //       Toast.fail('未查询到对应的服务企业')
    //     } else if (this.userInfo.some(item => item.companyAccount === companyAccount && item.companySecretKey !== companySecretKey)) {
    //       Toast.fail('企业秘钥错误')
    //     } else {
    //       Toast.fail('账号或密码错误')
    //     }
    //   }
    // },

    // 本地开发登录
    testLoginFn () {
      if (this.code !== '' && this.code !== null && this.code !== undefined) {
        sessionStorage.setItem('dialogCode', this.code)
        // 验证登录
        this.checkLogin()
      } else {
        Toast.fail('请先选择用户')
      }
    },
    // 验证登录
    checkLogin () {
      let params = {
        code: this.code,
        account: this.accountName
      }
      authorize(params).then(res => {
        if (res.code === 0) {
          // 保存token
          setToken(res.data.token)
          // 保存登录信息
          setLoginInfo(res.data)
          // 保存登录验证信息
          setCheckLoginInfo(res.data)
          // 存储登录企业账号信息
          setAccountInfo(this.accountName)
          // 获取配置信息
          this.getConfigInfoFn()
        } else {
          this.$router.push({
            path: '/error',
            query: {
              msg: res.msg
            }
          })
        }
      })
    },
    // 获取配置信息
    getConfigInfoFn () {
      let params = {
        account: this.accountName
      }
      getConfigInfo(params).then(res => {
        if (res.code === 0) {
          // 存储配置信息
          setConfig(res.data)
          this.$router.push({
            path: '/'
          })
        } else {
          this.$router.push({
            path: '/error',
            query: {
              msg: res.msg
            }
          })
        }
      })
    },
    onConfirm (value) {
      this.testName = value.name
      this.code = value.code
      this.showPicker = false
    }
  },
  mounted () {
    let accountData = JSON.parse(localStorage.getItem('account'))
    if (accountData && accountData.nickname) {
      this.loginData.nickname = accountData.nickname
      this.loginData.password = accountData.password
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  position: relative;
}

/* 顶部蓝色渐变区域 */
.header-section {
  width: 100%;
  height: 26%;
  background: #002DA2;
}

/* 白色卡片层 */
.card-section {
  position: absolute;
  top: 5%;
  left: 50%;
  bottom: 2%;
  transform: translateX(-50%);
  width: 80%;
  max-width: 400px;
  min-height: 420px;
  background: linear-gradient(180deg, #4468bc 0%, #f5fafd 30%, #ffffff 70%, #ffffff 100%);
  border-radius: 10px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 40px 20px 50px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
}

/* Logo区域 */
.logo-area {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
}

.debaoImg {
  width: 200px;
  height: auto;
}

/* 系统标题 */
.system-title {
  text-align: center;
  margin-bottom: 35px;
  margin-top: 36px;
}

.system-title h1 {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0 0 2px 0;
}

.system-title p {
  font-size: 12px;
  font-weight: 600;
  color: #666666;
  margin: 0;
}

/* 登录表单 */
.login-form {
  width: 100%;
  max-width: 280px;
}

.input-wrapper {
  margin-bottom: 16px;
}

.username-field {
  background-color: #ffffff;
  border-radius: 25px;
  border: 1px solid #B3B3B3;
}

.username-field /deep/ .van-field__control {
  text-align: center;
  font-size: 15px;
  color: #333333;
}

.username-field /deep/ .van-field__control::placeholder {
  color: #000000 !important;
}

.username-field /deep/ .van-cell__value {
  text-align: center;
}

.login-btn {
  background-color: #ff4444;
  border: none;
  border-radius: 25px;
  height: 44px;
  font-size: 16px;
  color: #ffffff;
  margin-top: 10px;
}

.login-btn /deep/ .van-button__text {
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/pages/login.vue